import React from 'react';
import { formatDollar } from '../../../helpers/utils';
const Row = ({
  employee,
  accent_color
}) => {
  var _employee$name;
  const employeeHasSales = Object.hasOwn(employee, 'sales');
  return /*#__PURE__*/React.createElement("div", {
    className: "list-row list-item",
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, employee.ranking, "."), " ", (_employee$name = employee.name) === null || _employee$name === void 0 ? void 0 : _employee$name.toLowerCase()), /*#__PURE__*/React.createElement("div", {
    className: "guest_total"
  }, employee.guests ? employee.guests : '-'), /*#__PURE__*/React.createElement("div", {
    className: "amount"
  }, employeeHasSales ? /*#__PURE__*/React.createElement("div", null, `${formatDollar(employee.sales, 2)}`) : '-'));
};
export default Row;